










import { Component, Vue } from 'vue-property-decorator';
import Bucp from '@/components/about/BUCP.vue';
import Partners from '@/components/about/Partners.vue';

@Component({
  components: {
    Bucp,
    Partners,
  },
})
export default class About extends Vue {}
